import React from "react";
import CommentsComponent from "../../comments/comments";
import { useParams } from "react-router-dom";

const CustomerCommentsList = () => {
  const { id } = useParams();
  return (
    <main>
      <CommentsComponent tableName={"customer"} viewId={id} />
    </main>
  );
};

export default CustomerCommentsList;
